import { Redirect, Route as RouteComponent, Switch } from 'react-router-dom'

import { Route } from 'modules/Monitoring/consts/routes'
import { MonitoringRoutes } from 'modules/Monitoring/MonitoringRoutes'

export const AppRoutes = () => {
  return (
    <Switch>
      <RouteComponent path={Route.Monitoring}>
        <MonitoringRoutes />
      </RouteComponent>

      <Redirect to={Route.Monitoring} />
    </Switch>
  )
}
